import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Gift, Heart } from 'lucide-react';
import Navbar from '../components/Navbar';
const GiftsPage = () => {
  const navigate = useNavigate();
  const giftOptions = [{
    title: 'Home Essentials',
    description: 'Help us build our new home together with essential items for our journey as a married couple.',
    icon: <Heart size={32} className="text-emerald" data-id="element-195" />,
    path: '/gifts/home-essentials',
    items: '30+ items available'
  }, {
    title: 'Honeymoon Fund',
    description: 'Contribute to our dream honeymoon and help us create unforgettable memories together.',
    icon: <Gift size={32} className="text-emerald" data-id="element-196" />,
    path: '/gifts/honeymoon-fund',
    items: 'Multiple contribution options'
  }];
  return <div className="min-h-screen bg-cream" data-id="element-197">
      <Navbar data-id="element-198" />

      <div className="section-container pt-24" data-id="element-199">
        <button onClick={() => navigate('/')} className="flex items-center text-gray-700 hover:text-emerald mb-8 transition-colors" data-id="element-200">
          <ArrowLeft size={20} className="mr-2" data-id="element-201" />
          Back to Invitation
        </button>

        <div className="max-w-5xl mx-auto" data-id="element-202">
          <h1 className="section-heading" data-id="element-203">Gifts & Wishes</h1>
          <p className="text-center text-gray-700 max-w-2xl mx-auto mb-12 font-elegant" data-id="element-204">
            Your presence at our wedding is the greatest gift of all. However,
            if you wish to honor us with a gift, we've included some options
            below.
          </p>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-205">
            {giftOptions.map((option, index) => <div key={index} className="bg-white border-2 border-sage border-opacity-60 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300" data-id="element-206">
                <div className="p-10 text-center" data-id="element-207">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-sage rounded-full mb-6" data-id="element-208">
                    {option.icon}
                  </div>
                  <h3 className="font-serif text-2xl mb-4 text-gray-800" data-id="element-209">
                    {option.title}
                  </h3>
                  <p className="text-gray-700 mb-4 leading-relaxed font-elegant" data-id="element-210">
                    {option.description}
                  </p>
                  <p className="text-sm text-gray-500 mb-6 italic" data-id="element-211">
                    {option.items}
                  </p>
                  <button onClick={() => navigate(option.path)} className="w-full px-8 py-4 bg-emerald text-white font-sans text-sm uppercase tracking-wider hover:bg-emerald-dark transition-all duration-300 shadow-md" data-id="element-212">
                    View Options
                  </button>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-213">
            <p className="text-gray-600 italic font-script text-xl" data-id="element-214">
              Thank you for celebrating with us and for your generous support!
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default GiftsPage;